import React, { useState } from 'react';
import { CheckCircleOutlined, ClockCircleOutlined, DownOutlined, RightOutlined } from '@ant-design/icons';
import { Timeline, Typography } from 'antd';
import { dateFromString } from '../../../../utils/dateFromString';

const { Item } = Timeline;
const { Text } = Typography;

export default function TimelineComponent({ timeline, estatusActual }) {
  const [expandedItems, setExpandedItems] = useState({});

  if (!timeline) return null;

  const toggleExpand = (index) => {
    setExpandedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const getAutorizacionLabel = (comentario) => {
    if (!comentario) return null;
    const comentarioLower = comentario.toLowerCase();
    if (comentarioLower.includes('contención')) return 'Contención';
    if (comentarioLower.includes('primer')) return 'Autorización';
    if (comentarioLower.includes('segundo')) return 'Autorización 2';
    return null;
  };

  const renderHistorial = (historial, itemIndex, isExpanded) => {
    if (!historial) return null;

    if (!isExpanded) return null;

    if (Array.isArray(historial) && historial.length > 0) {
      return (
        <div style={{ marginTop: 2 }}>
          {historial.map((h, idx) => {
            const label = getAutorizacionLabel(h.comentario);
            return (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                {label && (
                  <Text strong style={{ fontSize: '10px' }}>
                    {label}:
                  </Text>
                )}
                <Text type="secondary" style={{ fontSize: '10px' }}>
                  {dateFromString(h.fecha)?.f1}
                </Text>
                {h.nombre && (
                  <>
                    <Text type="secondary" style={{ fontSize: '10px' }}>-</Text>
                    <Text type="secondary" style={{ fontSize: '10px' }}>
                      {h.nombre}
                    </Text>
                  </>
                )}
              </div>
            );
          })}
        </div>
      );
    }

    return (
      <div style={{ marginTop: 2, display: 'flex', alignItems: 'center', gap: 4 }}>
        <Text type="secondary" style={{ fontSize: '10px' }}>
          {dateFromString(historial.fecha)?.f1}
        </Text>
        {historial.nombre && (
          <>
            <Text type="secondary" style={{ fontSize: '10px' }}>-</Text>
            <Text type="secondary" style={{ fontSize: '10px' }}>
              {historial.nombre}
            </Text>
          </>
        )}
      </div>
    );
  };

  const hasMultipleItems = (historial) => {
    return Array.isArray(historial) && historial.length > 1;
  };

  return (
    <div style={{ overflowY: 'auto', maxHeight: 375, paddingLeft: 8 }}>
      <Timeline style={{ marginTop: 4 }} mode="left">
        {timeline.map((item, index) => {
        const isExpanded = expandedItems[index];
        const hasHistorial = Array.isArray(item.historial)
          ? item.historial.length > 0
          : (item.historial !== null && item.historial !== undefined);

        return (
          <Item
            key={index}
            dot={item.completado ? <CheckCircleOutlined style={{ fontSize: '14px' }} /> : <ClockCircleOutlined style={{ fontSize: '14px' }} />}
            color={item.completado ? 'green' : 'gray'}
          >
            <div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6
              }}>
                <div style={{
                  fontWeight: item.completado ? 600 : 400,
                  fontSize: '12px'
                }}>
                  {item.estado}
                </div>
                {hasHistorial && (
                  <div
                    onClick={() => toggleExpand(index)}
                    style={{
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    {isExpanded ? (
                      <DownOutlined style={{ fontSize: '9px', color: '#8c8c8c' }} />
                    ) : (
                      <RightOutlined style={{ fontSize: '9px', color: '#8c8c8c' }} />
                    )}
                  </div>
                )}
              </div>
              {hasHistorial && renderHistorial(item.historial, index, isExpanded)}
            </div>
          </Item>
        );
      })}
      </Timeline>
    </div>
  );
}